// AI-CONTEXT: See docs/features/impact-in-beeld-hub.md

/**
 * Parses user price input (Dutch notation allowed) into a number.
 * Accepts "2,50", "2.50", "1.250,50", "€ 2,50" and plain numbers.
 *
 * @param {number|string|null|undefined} input - raw price input
 * @returns {number|null} the price in euros (>= 0), or null when the input
 *   is empty, non-numeric or negative
 */
const parsePrice = (input) => {
  if (typeof input === 'number') {
    return Number.isFinite(input) && input >= 0 ? input : null
  }

  if (typeof input !== 'string') return null

  const cleaned = input.replace(/€/g, '').trim()
  if (cleaned === '') return null

  // With both separators present the dot is a Dutch thousands separator;
  // with only a comma it is the decimal separator.
  const normalized = cleaned.includes(',')
    ? cleaned.replace(/\./g, '').replace(',', '.')
    : cleaned

  if (!/^-?\d+(\.\d+)?$/.test(normalized)) return null

  const price = Number(normalized)
  return price >= 0 ? price : null
}

export { parsePrice }
